import styled from "styled-components";

export const MenuButtonContainer = styled.div<{ isLast: boolean }>`
	margin-bottom: ${props => (props.isLast ? `0` : `1em`)};
`;
